// services/entities/AiServicesEntity.js
const AiServicesEntity = (backClient) => ({
  /**
   * Récupérer tous les AI Services
   */
  getAiServices: async () => {
    const { data } = await backClient.get("/api/ai_services")
    return data // <- Important, retourne la liste
  },

  /**
   * Créer un nouvel AI Service
   * @param {FormData} formData
   */
  decentralizedAiServiceUpload: async (formData) => {
    const { data } = await backClient.post("/api/ai_services", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data
  },

  /**
   * Mettre à jour un AI Service existant
   * @param {number|string} id
   * @param {FormData} formData
   */
  decentralizedAiServiceUploadUpdate: async (id, formData) => {
    const { data } = await backClient.put(`/api/ai_services/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data
  },

  /**
   * Supprimer un AI Service
   * @param {number|string} id
   */
  decentralizedAiServiceUploadDelete: async (id) => {
    const { data } = await backClient.delete(`/api/ai_services/${id}`)
    return data
  },

  /**
   * Dupliquer un AI Service
   * @param {number|string} id
   */
  duplicateAiService: async (id) => {
    const { data } = await backClient.post(
      `/api/ai_services/${id}/duplicate`,
      {}
    )
    return data
  },

  /**
   * Récupérer la liste des providers
   */
  getProviders: async () => {
    const { data } = await backClient.get("/api/ai_services/providers")
    return data
  },

  /**
   * Récupérer les modèles selon un provider
   * @param {string|number} providerId
   */
  getModelsByProvider: async (providerId) => {
    const { data } = await backClient.post(
      "/api/ai_services/models_by_provider",
      {
        provider_name: providerId,
      }
    )
    return data
  },

  /**
   * Récupérer providers + models
   */
  getProvidersWithModels: async () => {
    const { data } = await backClient.get(
      "/api/ai_services/providers_with_models"
    )
    return data // { providerName: [models...] }
  },
})

export default AiServicesEntity
